module.exports = __webpack_public_path__ + "static/media/exclamation.0ce1e720.svg";